import React from 'react';
import ReactDOM from 'react-dom';
import Photoswipe from 'photoswipe';
import PhotoswipeUIDefault from 'photoswipe/dist/photoswipe-ui-default';
import classnames from 'classnames';
import events from './events';

export class PhotoSwipe extends React.Component<
  {
    className?: string;
    closePhotoSwipeCb: () => void;
    id?: string;
    isOpen: boolean;
    items: any[];
    options: any;
  },
  { isOpen: boolean }
> {
  photoSwipe: Photoswipe<any>;

  // eslint-disable-next-line react/static-property-placement
  static defaultProps = {
    items: [],
    options: {},
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  componentDidMount = () => {
    const { isOpen } = this.state;
    if (isOpen) {
      this.openPhotoSwipe(this.props);
    }
  };

  UNSAFE_componentWillReceiveProps = nextProps => {
    const { isOpen } = this.state;
    if (nextProps.isOpen) {
      if (!isOpen) {
        this.openPhotoSwipe(nextProps);
      } else {
        this.updateItems(nextProps.items);
      }
    } else if (isOpen) {
      this.closePhotoSwipe();
    }
  };

  componentWillUnmount = () => {
    this.closePhotoSwipe();
  };

  openPhotoSwipe = props => {
    const { items, options } = props;
    const pswpElement = ReactDOM.findDOMNode(this) as HTMLElement; // eslint-disable-line
    this.photoSwipe = new Photoswipe(pswpElement, PhotoswipeUIDefault, items, options);
    events.forEach(event => {
      const callback = props[event];
      if (callback || event === 'destroy') {
        this.photoSwipe.listen(event, (...args: any[]) => {
          if (callback) {
            args.unshift(this);
            callback(...args);
          }
          if (event === 'destroy') {
            this.handleClose();
          }
        });
      }
    });
    this.setState({ isOpen: true }, () => {
      this.photoSwipe.init();
    });
  };

  updateItems = (items = []) => {
    this.photoSwipe.items.length = 0;
    items.forEach(item => {
      this.photoSwipe.items.push(item);
    });
    this.photoSwipe.invalidateCurrItems();
    this.photoSwipe.updateSize(true);
  };

  closePhotoSwipe = () => {
    if (!this.photoSwipe) {
      return;
    }
    this.photoSwipe.close();
  };

  handleClose = () => {
    const { closePhotoSwipeCb } = this.props;
    this.setState({ isOpen: false });
    closePhotoSwipeCb();
  };

  handleBackgroundClick = e => {
    e.stopPropagation();

    const classList = e?.target?.classList || [];
    if (
      classList.contains('pswp__item') ||
      classList.contains('pswp__zoom-wrap') ||
      classList.contains('pswp__top-bar')
    ) {
      this.closePhotoSwipe();
    }
  };

  render() {
    const { id } = this.props;
    let { className } = this.props;
    className = classnames(['pswp', className]).trim();
    return (
      <div aria-hidden="true" className={className} id={id} role="dialog" tabIndex={-1}>
        {/* eslint-disable react/button-has-type */}
        <div className="pswp__bg" />
        <div className="pswp__scroll-wrap">
          <div className="pswp__container" onClick={this.handleBackgroundClick}>
            <div className="pswp__item" />
            <div className="pswp__item" />
            <div className="pswp__item" />
          </div>
          <div className="pswp__ui pswp__ui--hidden">
            <div className="pswp__top-bar" onClick={this.handleBackgroundClick}>
              <div className="pswp__counter" />
              <button className="pswp__button pswp__button--close" title="Close (Esc)" />
              <button className="pswp__button pswp__button--share" title="Share" />
              <button className="pswp__button pswp__button--fs" title="Toggle fullscreen" />
              <button className="pswp__button pswp__button--zoom" title="Zoom in/out" />
              <div className="pswp__preloader">
                <div className="pswp__preloader__icn">
                  <div className="pswp__preloader__cut">
                    <div className="pswp__preloader__donut" />
                  </div>
                </div>
              </div>
            </div>
            <div className="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
              <div className="pswp__share-tooltip" />
            </div>
            <button className="pswp__button pswp__button--arrow--left" title="Previous (arrow left)" />
            <button className="pswp__button pswp__button--arrow--right" title="Next (arrow right)" />
            <div className="pswp__caption">
              <div className="pswp__caption__center" />
            </div>
          </div>
        </div>
        {/* eslint-enable react/button-has-type */}
      </div>
    );
  }
}

export default PhotoSwipe;
